import { Component, OnDestroy, OnInit } from '@angular/core';
import { NewEnvelopeSteps } from '../../enum/new-envelope-steps';
import { NewEnvelopeService } from './new-envelope.service';
import { IToast, LayoutService, ToastService, IOnboarding, OnboardingService } from 'codex-lib';
import { TranslateService } from '@ngx-translate/core';
import * as R from 'ramda';
import { FileValidateService } from '../services/file-validate.service';
import { Subscription } from 'rxjs';
import { FileState } from '../model/file-state';
import { StateFile } from 'src/app/enum/state-file.enum';
import { BrowserUtil } from 'src/app/util/browser-util';
import { RegexUtil } from 'src/app/util/regex-util';
import { TrackerData } from 'src/app/modules/google-analytics/model/tracker-data.model';
import { AnalyticEventClient } from 'src/app/enum/analytic-event-client.enum';
import { AnalyticsService } from 'src/app/modules/google-analytics/service/analytics.service';

const TOAST: IToast = {
  text: '',
  autoHide: true,
  type: 'danger'
};

@Component({
  selector: 'app-new-envelope',
  templateUrl: './new-envelope.component.html',
  styleUrls: ['./new-envelope.component.scss']
})
export class NewEnvelopeComponent implements OnInit, OnDestroy {

  formData: FormData;
  files: File[] = [];
  progress: number;
  sumSize = 0;
  maxSizeAttachFiles = 70;
  maxSize: number = this.maxSizeAttachFiles * 1024 * 1024;
  subscriptionFileName: Subscription;
  subscriptionFileConfig: Subscription;
  subscriptionMergeFiles: Subscription;
  onboarding: IOnboarding[] = [];
  isMobile: boolean = BrowserUtil.isMobile();
  showOnboardingMobile: boolean;

  constructor(
    private newEnvelopeService: NewEnvelopeService,
    private toastService: ToastService,
    private translate: TranslateService,
    public fileValidateService: FileValidateService,
    private layoutService: LayoutService,
    private onboardingService: OnboardingService,
    private googleAnalitycsService: AnalyticsService) {
    const data = this.newEnvelopeService.getModelData(NewEnvelopeSteps.Upload);
    this.files = R.pathOr(0, ['length'], data) >= 1 ? data : [];

    this.subscriptionFileName = this.fileValidateService.getSubjectFileName()
      .subscribe((res: FileState) => {
        this.validStateFile(res);
      });

    this.subscriptionFileConfig = this.fileValidateService.getSubjectFileConfig()
      .subscribe((res: FileState) => {
        this.validStateFile(res);
      });

    this.subscriptionMergeFiles = this.fileValidateService.getSubjectMergeFiles()
      .subscribe((res: FileState) => {
        this.validStateFile(res);
      });
  }

  ngOnDestroy() {
    this.subscriptionFileName.unsubscribe();
    this.subscriptionFileConfig.unsubscribe();
    this.subscriptionMergeFiles.unsubscribe();
    this.fileValidateService.mergePDF = false;
  }

  ngOnInit(): void {
    this.addEventListenerToListButtons();
  }

  sumFileSize() {
    this.sumSize = 0;
    for (let index = 0; index < this.files.length; index++) {
      const sizeFile = this.files[index].size;
      this.sumSize = this.sumSize + sizeFile;
    }
  }
  sumFileMaxSize() {
    if (this.sumSize > this.maxSize) {
      this.toastService.createNewToast({
        text: this.translate.instant('new-envelope.toast.maxSizeLimitMerge'),
        autoHide: true,
        type: 'danger',
        delay: 10000
      });
      this.disabledMergeFiles();
    }
  }

  addEventListenerToListButtons() {
    const fileListEl = document.querySelector('.container-file');
    if (fileListEl) {
      fileListEl.querySelector('fa-icon').addEventListener('click', (ev) => {
        this.files = this.newEnvelopeService.setModelData([]);
      });
    }
  }

  onFilesDragDrop(files: File[]) {
    this.googleAnalitycsService.sendEvent(
      new TrackerData(
        AnalyticEventClient.TK_PT_SIGNER_NEW_ENVELOPE,
        'Signer_NovEnv_UploadArraste'
      )
    );

    this.files = files;
    this.handleFilesAdded();
  }

  onFilesSelected(files: FileList) {
    if (files && files.length > 0) {
      this.files = [...this.files, ...Array.from(files)];

      this.googleAnalitycsService.sendEvent(
        new TrackerData(
          AnalyticEventClient.TK_PT_SIGNER_NEW_ENVELOPE,
          'Signer_NovEnv_UploadClique'
        )
      );
      this.handleFilesAdded();
    }
  }

  handleFilesAdded() {
    this.layoutService.toggleLoading(true);
    this.checkFileExtensionAndReplaceExtraDotsFromFileName();
    this.fileValidateService.validFileName(this.files);
    this.fileValidateService.mergePDF = false;
    this.sumFileSize();
    this.sumFileMaxSize();
  }

  filechange() {
    this.layoutService.toggleLoading(true);
    this.checkFileExtensionAndReplaceExtraDotsFromFileName();
    this.fileValidateService.validFileName(this.files);
    this.fileValidateService.mergePDF = false;
    this.sumFileSize();
    this.sumFileMaxSize();
  }

  deleteFile(indexFile: number) {
    const FILE_NAME = this.removeExt(this.files[indexFile].name);
    this.sumFileSize();
    const sizeFile = this.files[indexFile].size;
    this.sumSize = this.sumSize - sizeFile;
    this.sumFileMaxSize();
    this.fileValidateService.deleteFileConfig(FILE_NAME);
    this.newEnvelopeService.deleteFilesUploads(indexFile);
  }


  checkFileExtensionAndReplaceExtraDotsFromFileName() {
    this.files.forEach((file, index) => {
      const isValid = new RegExp(RegexUtil.FILES_ENVELOPES).test(this.files[index].name);

      if ((file.name.split('.').length > 2) || !isValid) {
        const extensionFile = '.' + this.files[index].name.split('.').pop().toLowerCase()
        const myNewFile = new File([file], file.name.split('.').slice(0, -1).join('.').replace(/\./g, "_") + extensionFile, { type: file.type });
        this.files[index] = myNewFile;
      };
    });
  }

  removeExt(fileName: string) {
    return fileName.split('.').slice(0, -1).join('.');
  }

  validStateFile(fileState: FileState) {
    switch (fileState.state) {
      case StateFile.END_QUEUE_1:
        this.fileValidateService.validFileConfig(this.files);
        break;
      case StateFile.MERGED:
        let fileNames = '';
        this.files.forEach((x, index) => {
          if ((index + 1) < this.files.length) {
            fileNames = fileNames + x.name + ', ';
          } else {
            fileNames = fileNames + x.name;
          }
        });

        this.files = [];
        this.fileValidateService.fileConfig = [];
        this.files.push(fileState.file);
        this.newEnvelopeService.setModelData(this.files);
        this.fileValidateService.validFileName(this.files);

        this.toastService.createNewToast({
          text: this.translate.instant('mergedFiles', { files: fileNames }),
          autoHide: true,
          type: 'success'
        });
        break;
      case StateFile.FINNALY:

        //solução paliativa
        if (this.checkIfHasNotPdf()) {
          setTimeout(() => {
            this.newEnvelopeService.setModelData(this.files);
            this.layoutService.toggleLoading(false);
          }, 5000);
        } else {
          this.newEnvelopeService.setModelData(this.files);
          this.layoutService.toggleLoading(false);
        }
        break;
      case StateFile.CONVERTED:
        const FILE_NAME = this.removeExt(fileState.file.name);
        const INDEX = this.files.indexOf(this.files.find(x => this.removeExt(x.name) === FILE_NAME));
        this.files[INDEX] = fileState.file;
        break;
      case StateFile.ENCRYPTED:
        TOAST.text = this.translate.instant('new-envelope.toast.encryptedFile');
        this.toastService.createNewToast(TOAST);
        this.files.splice(this.files.indexOf(fileState.file), 1);
        break;
      case StateFile.CORRUPTED:
        TOAST.text = this.translate.instant('new-envelope.toast.corruptedFile');
        this.toastService.createNewToast(TOAST);
        this.files.splice(this.files.indexOf(fileState.file), 1);
        break;
      case StateFile.INVALID_EXTENSION:
        this.files.indexOf(fileState.file);
        TOAST.text = this.translate.instant('new-envelope.toast.invalidFile');
        this.toastService.createNewToast(TOAST);
        this.files.splice(this.files.indexOf(fileState.file), 1);
        break;
      case StateFile.DUPLICATE:
        TOAST.text = this.translate.instant('new-envelope.toast.invalidFileName');
        this.toastService.createNewToast(TOAST);
        this.files.splice(this.files.indexOf(fileState.file), 1);
        break;
      case StateFile.MAX_SIZE_LIMIT:
        TOAST.text = this.translate.instant('new-envelope.toast.maxSizeLimit');
        this.toastService.createNewToast(TOAST);
        this.files.splice(this.files.indexOf(fileState.file), 1);
        break;
      default:
        break;
    }
  }

  onToggleMergeFiles(event: boolean) {
    if (event) {
      this.fileValidateService.mergePDF = true;
      this.fileValidateService.mergePDFDocuments();
    }
  }

  disabledMergeFiles() {
    if (R.pathOr(0, ['length'], this.files) <= 1 || this.sumSize > this.maxSize)
      return true;
  }

  checkIfHasNotPdf() {
    this.files.forEach(file => {
      if (file.type != 'application/pdf')
        return true;
    });
    return false;
  }

}
